import SpecialMarket, { SpecialMarketIncomplete } from '@core/models/specials/SpecialMarket';
import SpecialOdd from '@core/models/specials/SpecialOdd';
import { OfferStatus } from '@core/models/offer/enums';
import ISportlikeEvent from '../base/ISportlikeEvent';
import SpecialMarketEvent from './SpecialMarketEvent';
import Rule from '../shared/betSlip/Rule';

export interface ISpecialEventIncomplete {
    id: number;
    fullName: string;
    masterName: string;
    markets: SpecialMarketIncomplete[] | SpecialMarket[];
    date: Date;
    order: number;
}

export interface ISpecialEvent extends ISpecialEventIncomplete {
    header: string;
    footer: string;
    status: OfferStatus;
    tournamentId?: number;
    sportId: number;
    date: Date;
    order: number;
    markets: SpecialMarket[];
}

export class SpecialEventIncomplete implements ISpecialEventIncomplete {
    id: number;
    fullName: string;
    masterName: string;
    markets: SpecialMarketIncomplete[];
    date: Date;
    order: number;

    constructor(data: ISpecialEventIncomplete) {
        Object.assign(this, data);
    }

    public isCurrentlyOffered() {
        return this.markets.some((market) => market.isCurrentlyOffered());
    }

    public isAvailableForBetting() {
        return this.markets.some((market) => market.isAvailableForBetting());
    }

}

export default class SpecialEvent extends SpecialEventIncomplete implements ISportlikeEvent {
    id: number;
    header: string;
    footer: string;
    markets: SpecialMarket[];
    status: OfferStatus;
    tournamentId?: number;
    sportId: number;
    fullName: string;
    masterName: string;
    date: Date;
    rules = [] as Rule[];
    betRadarId: string | number;
    isFull = true;

    public isLocked = false; // TODO check

    constructor(data: ISpecialEvent) {
        super(data);
        Object.assign(this, data);
    }

    public getOdd(oddId: number, specialBetValue?: string, uuid?: string) {
        return this.getOddById(oddId);
    }

    public getOddById(oddId: number) {
        let foundOdd;
        let parentOddType: SpecialMarketEvent;
        let parentMarket: SpecialMarket;
        for (let i = 0; i < this.markets.length; i += 1) {
            for (let j = 0, market = this.markets[i]; j < market.specialMarketEvents.length; j += 1) {
                for (let k = 0, oddType = market.specialMarketEvents[j]; k < oddType.odds.length; k += 1) {
                    const odd = oddType.odds[k];
                    if (odd.id === oddId) {
                        foundOdd = odd;
                        parentOddType = oddType;
                        parentMarket = market;
                        i = this.markets.length;
                        j = market.specialMarketEvents.length;
                        break;
                    }
                }
            }
        }

        if (foundOdd) {
            const odd = new SpecialOdd(foundOdd, parentOddType!, parentMarket!);
            return odd;
        }
        return undefined;
    }

    public isOngoing() {
        return false;
    }

    public isFinished() {
        const now = new Date();
        return now > this.date;
    }
}
export const SPECIAL_EVENT_PREFIX = 'S';

export function isSpecialEvent(id: string) {
    return id.startsWith(SPECIAL_EVENT_PREFIX);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/specials/SpecialEvent.ts